import { Emitter, Event } from "../../../../../features/event-emitter"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { usePaymentOrderActions } from "../../../actions/paymentOrderActions"

export const useActions = () => {
    const { getRoutePath } = useRoutesHooks()
    const paymentOrderActions = usePaymentOrderActions()

    const submitReceipt = async (
        paymentOrderId: string,
        receiptFile: File
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        
        const { uploadPaymentReceipt } = paymentOrderActions()
        await uploadPaymentReceipt(paymentOrderId, receiptFile)

        const paymentOrderPath = getRoutePath(RoutePath.PAYMENT_ORDERS, paymentOrderId)
        Emitter.emit(Event.DB_SUBMIT_DONE, false, false, paymentOrderPath)
    }
    
    return {
        submitReceipt
    }
}
